(function () {
  'use strict'

  const MODULE_NAME = 'thismoment.common.formly.inputs.email-verify'

  require('angular')
    .module(MODULE_NAME, [
      require('angular-formly'),
      require('angular-formly-templates-bootstrap')
    ])
    .run(emailVerifyConfig)

  emailVerifyConfig.$inject = ['formlyConfig', 'SdkConfig', 'FormlyMessageStrings']
  function emailVerifyConfig (formlyConfig, SdkConfig, FormlyMessageStrings) {
    formlyConfig.setType({
      name: 'email-verify',
      extends: 'input',
      controller: emailVerifyController,
      defaultOptions: {
        validators: {
          matchEmail: {
            expression: function ($viewValue, $modelValue, scope) {
              var value = $modelValue || $viewValue
              var compareField = scope.to.compareField || 'email'
              if (value === scope.model[compareField]) {
                return true
              }
              return false
            },
            message: function (viewValue, modelValue, scope) {
              var compareLabel = scope.to.compareLabel || 'Email'
              return FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.ERROR'] + ': ' +
                     FormlyMessageStrings[SdkConfig.get('language')]['FORMLY.MESSAGE.EMAIL.MISMATCH'] +
                     ' (' + compareLabel + ')'
            }
          }
        }
      },
      wrapper: ['bootstrapLabel', 'bootstrapHasError']
    })
  }

  emailVerifyController.$inject = ['$scope']
  function emailVerifyController ($scope) {
    var compareField = $scope.to.compareField || 'email'

    $scope.$watch('model.' + compareField, function (newValue, oldValue) {
      // Only validate if the value has changed and is not undefined
      if (newValue !== oldValue && newValue !== undefined) {
        if ($scope.fc) {
          $scope.fc.$validate()
        }
      }
    })

    // Add a watch on the current field as well
    $scope.$watch('model.' + $scope.options.key, function (newValue, oldValue) {
      // Only validate if the value has changed and is not undefined
      if (newValue !== oldValue && newValue !== undefined) {
        if ($scope.fc) {
          $scope.fc.$validate()
        }
      }
    })
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/inputs/email-verify.js